import { NodeInstance } from '@glueapp/graph-types';
import { NodeStandardLayout } from '@/GraphEditor/drawingLayer/nodeComposition/NodeStandardLayout';

interface Props {
    nodeInstance: NodeInstance;
}

export const StandardNode: React.FC<Props> = ({ nodeInstance }) => {
    return <NodeStandardLayout nodeInstance={nodeInstance} />;
};
